import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { aboutMe } from '../models/aboutMe';
const AboutMeWidget = () => {
    return (_jsx("div", { className: "about-me-widget", children: aboutMe.map((about) => (_jsxs("div", { children: [_jsx("img", { src: about.image, alt: about.title }), _jsx("h2", { children: about.title }), _jsx("p", { children: about.description })] }, about.id))) }));
};
export default AboutMeWidget;
